(function () {
  'use strict';

  var MAX_LENGTH = 150;
  var DEBOUNCE_MS = 800;
  var STATUS_FADE_MS = 2500;

  /* ---- DOM helpers ---- */

  function $(sel, root) {
    return (root || document).querySelector(sel);
  }

  function $$(sel, root) {
    return Array.from((root || document).querySelectorAll(sel));
  }

  /* ---- Cart API ---- */

  function addAddon(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    }).then(function (r) {
      if (!r.ok) throw new Error('add_failed');
      return r.json();
    });
  }

  function saveMessage(lineKey, message) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: 1, properties: { Message: message } })
    }).then(function (r) {
      if (!r.ok) throw new Error('save_failed');
      return r.json();
    });
  }

  function removeAddon(variantId) {
    var updates = {};
    updates[variantId] = 0;
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (r) {
      if (!r.ok) throw new Error('remove_failed');
      return r.json();
    });
  }

  function refreshCart() {
    document.dispatchEvent(new CustomEvent('theme:update:cart'));
  }

  /* ---- UI helpers ---- */

  function togglePanel(container, show) {
    var panel = $('[data-addon-panel]', container);
    if (panel) panel.classList.toggle('carte-perso__panel--hidden', !show);
    var cb = $('.js-addon-toggle', container);
    if (cb) cb.setAttribute('aria-expanded', show ? 'true' : 'false');
  }

  function updateCounter(container) {
    var ta = $('.js-addon-message', container);
    var countEl = $('[data-addon-count]', container);
    var counterWrap = $('.carte-perso__counter', container);
    if (!ta || !countEl) return;

    var len = ta.value.length;
    countEl.textContent = String(len);

    if (counterWrap) {
      counterWrap.classList.toggle('is-warning', len >= 120 && len < MAX_LENGTH);
      counterWrap.classList.toggle('is-limit', len >= MAX_LENGTH);
    }
  }

  function showSaving(container) {
    var el = $('[data-addon-status]', container);
    if (!el) return;
    el.innerHTML = '<span class="cp-spinner"></span><span>Sauvegarde...</span>';
    el.classList.add('is-visible', 'is-saving');
  }

  var statusTimer = null;

  function showSaved(container) {
    var el = $('[data-addon-status]', container);
    if (!el) return;
    el.innerHTML =
      '<svg class="carte-perso__status-icon" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>' +
      '<span>Sauvegard\u00e9</span>';
    el.classList.add('is-visible');
    el.classList.remove('is-saving');

    clearTimeout(statusTimer);
    statusTimer = setTimeout(function () {
      el.classList.remove('is-visible');
    }, STATUS_FADE_MS);
  }

  function hideStatus(container) {
    var el = $('[data-addon-status]', container);
    if (!el) return;
    el.classList.remove('is-visible', 'is-saving');
  }

  function showError(container, msg) {
    var el = $('[data-addon-error]', container);
    if (!el) return;
    if (msg) {
      el.textContent = msg;
      el.classList.remove('hidden');
    } else {
      el.textContent = '';
      el.classList.add('hidden');
    }
  }

  /* ---- Save state ----
     Les sauvegardes passent par une file (saveChain) : chacune lit la clé de ligne
     à jour, car Shopify la change à chaque modification des propriétés. Le message
     à sauvegarder est capturé depuis le champ saisi (tiroir ou page panier), jamais
     relu dans le premier bloc du DOM. */

  var debounceTimer = null;
  var pendingMessage = null;   /* saisi, pas encore envoyé */
  var failedMessage = null;    /* dernier envoi en échec, à retenter avant paiement */
  var lastSave = Promise.resolve();
  var saveChain = Promise.resolve();
  var inFlight = 0;
  var needsRefresh = false;
  var checkoutInProgress = false;
  var bypassSubmit = false;
  var addInFlight = null;      /* ajout de la carte en cours (le message saisi entre-temps attend la clé de ligne) */
  /* Audit 2026-11-03-2 (B01) : ajouts et retraits de la carte passent par une file, pour
     qu'un retrait ne double pas un ajout encore en cours. Le paiement attend la dernière
     opération ; si elle échoue, il est annulé (nouveau clic après lecture de l'erreur). */
  var mutationChain = Promise.resolve();
  var mutationPending = null;

  function queueMutation(run) {
    var p = mutationChain.then(run);
    mutationChain = p.catch(function () {});
    mutationPending = p;
    function clear() { if (mutationPending === p) mutationPending = null; }
    p.then(clear, clear);
    return p;
  }

  function cancelDebounce() {
    clearTimeout(debounceTimer);
    debounceTimer = null;
    pendingMessage = null;
  }

  /* Recopie le message sauvegardé dans les autres vues (sauf le champ en cours de saisie) */
  function syncViews(message) {
    $$('[data-addon-card]').forEach(function (c) {
      var ta = $('.js-addon-message', c);
      if (!ta || ta === document.activeElement || ta.value.trim() === message) return;
      ta.value = message;
      updateCounter(c);
      var preview = $('[data-addon-preview]', c);
      if (preview) preview.textContent = message || preview.getAttribute('data-placeholder') || '';
    });
  }

  function runSave(message) {
    var container = document.querySelector('[data-addon-card]');
    if (!container) return Promise.resolve();
    var variantId = Number(container.dataset.addonVariantId);
    var lineKey = container.dataset.addonLineKey;
    if (!lineKey) return Promise.resolve();

    $$('[data-addon-card]').forEach(function (c) { showError(c, null); showSaving(c); });

    return saveMessage(lineKey, message)
      .then(function (cart) {
        failedMessage = null;
        /* Update the line key in the DOM — it changes when properties change */
        if (cart && cart.items && variantId) {
          for (var i = 0; i < cart.items.length; i++) {
            if (cart.items[i].variant_id === variantId) {
              var newKey = cart.items[i].key;
              /* Update all addon containers (drawer + page) */
              $$('[data-addon-card]').forEach(function (c) {
                c.dataset.addonLineKey = newKey;
              });
              break;
            }
          }
        }
        $$('[data-addon-card]').forEach(showSaved);
        syncViews(message);

        /* Refresh cart to show message on line item — only once the queue is idle
           (skip if checkout in progress) */
        if (checkoutInProgress || inFlight > 1 || pendingMessage !== null) return;
        var activeEl = document.activeElement;
        if (!activeEl || !activeEl.matches('.js-addon-message')) {
          refreshCart();
          needsRefresh = false;
        } else {
          /* Textarea still has focus — defer refresh to blur */
          needsRefresh = true;
        }
      })
      .catch(function (err) {
        failedMessage = message;
        $$('[data-addon-card]').forEach(function (c) {
          showError(c, "Impossible de sauvegarder le message.");
          hideStatus(c);
        });
        throw err;
      });
  }

  function queueSave(message) {
    cancelDebounce();
    inFlight++;
    var p = saveChain.then(function () { return runSave(message.trim()); });
    function done() { inFlight--; }
    p.then(done, done);
    saveChain = p.catch(function () {});
    lastSave = p;
    return p;
  }

  /* ==========================
     EVENT HANDLERS
     ========================== */

  /* 1. Toggle ON/OFF */
  document.addEventListener('change', function (e) {
    var toggle = e.target.closest ? e.target.closest('.js-addon-toggle') : null;
    if (!toggle) return;

    var container = toggle.closest('[data-addon-card]');
    if (!container) return;

    var variantId = Number(container.dataset.addonVariantId);
    if (!variantId) return;

    showError(container, null);

    if (toggle.checked) {
      /* Optimistic UI — show panel immediately */
      togglePanel(container, true);

      /* Audit 2026-11-03 (A03) : le panneau s'ouvre avant la réponse, le client peut
         déjà écrire. Ce brouillon est gardé dans pendingMessage, puis enregistré
         dès que la clé de ligne est connue (sans re-rendu qui effacerait la saisie). */
      var adding = queueMutation(function () { return addAddon(variantId); })
        .then(function (item) {
          addInFlight = null;
          /* Décochée entre-temps : le retrait (en file) rafraîchit le panier */
          if (!toggle.checked) return;
          if (item && item.key) {
            $$('[data-addon-card]').forEach(function (c) { c.dataset.addonLineKey = item.key; });
          }
          if (pendingMessage !== null && item && item.key) {
            queueSave(pendingMessage).catch(function () {});
            return;
          }
          refreshCart();
          /* After re-render, scroll back to & focus the textarea so the
             user keeps their place and can immediately type. */
          setTimeout(function () {
            var ta = document.querySelector('[data-addon-card] .js-addon-message');
            if (!ta) return;
            try { ta.focus({ preventScroll: true }); } catch (e) { ta.focus(); }
            ta.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }, 350);
        })
        .catch(function (err) {
          addInFlight = null;
          cancelDebounce();
          showError(container, "Impossible d'ajouter la carte.");
          toggle.checked = false;
          togglePanel(container, false);
          throw err;
        });
      adding.catch(function () {});
      addInFlight = adding;
    } else {
      /* Optimistic UI — hide panel immediately */
      togglePanel(container, false);
      cancelDebounce();
      addInFlight = null;
      failedMessage = null;
      hideStatus(container);
      /* La ligne va disparaître : sa clé ne doit plus servir à une sauvegarde */
      var removedKey = container.dataset.addonLineKey;
      $$('[data-addon-card]').forEach(function (c) { c.dataset.addonLineKey = ''; });

      queueMutation(function () { return removeAddon(variantId); })
        .then(function () {
          refreshCart();
        }, function () {
          /* La carte est restée dans le panier : on remet l'interface (et sa clé) dans cet état */
          if (removedKey) $$('[data-addon-card]').forEach(function (c) { c.dataset.addonLineKey = removedKey; });
          toggle.checked = true;
          togglePanel(container, true);
          showError(container, 'Impossible de retirer la carte.');
        });
    }
  });

  /* 2. Textarea input — debounced auto-save */
  document.addEventListener('input', function (e) {
    if (!e.target.matches || !e.target.matches('.js-addon-message')) return;

    var container = e.target.closest('[data-addon-card]');
    if (!container) return;

    updateCounter(container);

    /* Aperçu du verso (design « aperçu écrit à la main », 2026-09-11) */
    var preview = $('[data-addon-preview]', container);
    if (preview) preview.textContent = e.target.value || preview.getAttribute('data-placeholder') || '';

    var message = e.target.value;
    clearTimeout(debounceTimer);
    pendingMessage = message;

    /* Carte en cours d'ajout : le brouillon sera enregistré à la fin de l'ajout */
    if (!container.dataset.addonLineKey) return;

    debounceTimer = setTimeout(function () {
      queueSave(message).catch(function () {});
    }, DEBOUNCE_MS);
  });

  /* 3. Textarea blur — save immediately if pending, or refresh if save already done */
  document.addEventListener('focusout', function (e) {
    if (!e.target.matches || !e.target.matches('.js-addon-message')) return;
    if (addInFlight) return;

    if (pendingMessage !== null) {
      queueSave(pendingMessage).catch(function () {});
    } else if (needsRefresh && !checkoutInProgress && inFlight === 0) {
      needsRefresh = false;
      refreshCart();
    }
  });

  /* 4. Checkout — le paiement attend que le message soit enregistré.
     Sinon un clic rapide sur « Commander » partirait avec l'ancien message. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.id !== 'cart') return;

    if (bypassSubmit) {
      bypassSubmit = false;
      checkoutInProgress = true;
      return;
    }

    var wait = null;
    if (mutationPending) {
      wait = mutationPending.then(function () {
        if (pendingMessage !== null) return queueSave(pendingMessage);
        if (inFlight > 0) return lastSave;
        if (failedMessage !== null) return queueSave(failedMessage);
      });
    }
    else if (pendingMessage !== null) wait = queueSave(pendingMessage);
    else if (inFlight > 0) wait = lastSave;
    else if (failedMessage !== null) wait = queueSave(failedMessage);

    checkoutInProgress = true;
    if (!wait) return;

    e.preventDefault();
    var submitter = e.submitter;
    if (submitter) submitter.setAttribute('aria-busy', 'true');

    wait.then(function () {
      if (submitter) submitter.removeAttribute('aria-busy');
      if (!submitter || !submitter.isConnected) {
        submitter = document.querySelector('input[type="submit"][name="checkout"][form="cart"]');
      }
      bypassSubmit = true;
      if (form.requestSubmit) {
        form.requestSubmit(submitter || undefined);
      } else {
        var hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'checkout';
        form.appendChild(hidden);
        form.submit();
      }
    }, function () {
      /* Échec : on reste sur le panier, l'erreur est affichée dans le bloc carte */
      if (submitter) submitter.removeAttribute('aria-busy');
      checkoutInProgress = false;
      var ta = document.querySelector('[data-addon-card] .js-addon-message');
      if (ta && ta.offsetParent !== null) {
        try { ta.focus({ preventScroll: true }); } catch (err) { ta.focus(); }
        ta.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else {
        var card = document.querySelector('[data-addon-card]');
        if (card) card.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  }, true);

  document.addEventListener('click', function (e) {
    if (e.target.matches && e.target.matches('input[name="checkout"]')) {
      checkoutInProgress = true;
    }
  });

})();
